import React from 'react';
import styles from './style.module.css';
import ContactForm from '../../components/forms/contact-email';

export default () => (
    <div className={styles.page}>
        <p className={styles.topTitle}>Great work completing a Prosperity Plan!</p>
        <h1 className={styles.mainTitle}>Want a Copy of Your Assessment?</h1>
        <p className={styles.text}>Fill in your details to get an emailed copy.</p>
        <ContactForm/>
    </div>
);
